import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import styles from './DSADisplay.module.scss';

export const DSADisplay = (props: {
    eventId: string;
    eventName: string;
    eventUrl: string;
}) => {
    const { eventId, eventName, eventUrl } = props;
    const illegalContentUrlTest = `https://ebrite-testing.nima.tremau.net/user-reports/?content.content_id=${eventId}&content.title=${eventName}&content.url=${eventUrl}&content.customerSpecific.entityId=${eventId}&content.type.id=IFRAME`;
    const illegalContentUrlProd = `https://ebrite.nima.tremau.net/user-reports/?content.content_id=${eventId}&content.title=${eventName}&content.url=${eventUrl}&content.customerSpecific.entityId=${eventId}&content.type.id=IFRAME`;
    const illegalContentUrl = eventUrl.includes('eventbrite')
        ? illegalContentUrlProd
        : illegalContentUrlTest;
    return (
        <p className={styles.dsaText} data-testid="reason_other-radio">
            {gettext(
                'To report other categories of prohibited or illegal content, submit',
            )}{' '}
            <a
                href={illegalContentUrl}
                rel="noopener noreferrer"
                target="_blank"
                title={gettext('this form').toString()}
            >
                {gettext('this form')}
            </a>
            .
        </p>
    );
};
